export default __webpack_public_path__ + "a93857ed8d0b316d35722803137516c2.woff2";